import ThemeController from 'shared-assets/lib/utils/controllers/ThemeController';

(function () {
  angular
    .module('kareo.ui.shared.directives.user.k-user-list-view', [
      'kareo.ui.shared.directives.templates',
      'kareo.ui.shared.directives.user.k-user-profile-image',
      'kareo.ui.shared.modules.authentication.k-roles',
      'ngCookies',
    ])
    .component('kUserListView', {
      bindings: {
        hasAvatars: '<?', // default true
        hasProductIcons: '<?', // default true
        hasProviderLabel: '<?', // default true
        hasRolesList: '<?', // default true
        showStatus: '<?', // default false
        onSelect: '&?',
        orderUsersBy: '<?',
        selectIconClass: '@?',
        selectText: '@?',
        users: '<'
      },
      controller,
      controllerAs: 'vm',
      template: require('./k-user-list-view.pug')()
    })
    .controller('ThemeController', ThemeController);

  controller.$inject = ['K_ROLES'];
  function controller(K_ROLES) {
    const vm = this;

    vm.roles = K_ROLES;
    vm.selectUser = selectUser;
    vm.isIncompleteProvider = isIncompleteProvider;
    vm.isComplete = isComplete;
    vm.isProviderShell = isProviderShell;

    vm.$onInit = init;

    // ---------------------------------------------------------------------

    function init() {
      vm.hasSelectAction = !!vm.onSelect && !!vm.selectText;
      vm.hasSelectIcon = !!vm.selectIconClass;

      vm.hasAvatars = trueIfNotFalse(vm.hasAvatars);
      vm.hasProductIcons = trueIfNotFalse(vm.hasProductIcons);
      vm.hasProviderLabel = trueIfNotFalse(vm.hasProviderLabel);
      vm.hasRolesList = trueIfNotFalse(vm.hasRolesList);

      if (!angular.isArray(vm.orderUsersBy)) {
        vm.orderUsersBy = ['firstName', 'lastName'];
        if (vm.hasProviderLabel) {
          vm.orderUsersBy.unshift('-isProvider');
        }
      }
    }

    function selectUser(user) {
      user.isProviderShell = isProviderShell(user);
      vm.onSelect({ user });
    }

    function isIncompleteProvider(user) {
      return !user.userGuid;
    }

    function isProviderShell(user) {
      return !!user.email && user.email.includes("@providerShell.com");
    }

    function isComplete(user) {
      return !!user.userGuid && !isProviderShell(user);
    }

    function trueIfNotFalse(value) {
      return value !== false;
    }
  }
})();
